/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R7_RetentionInputs */

const tr_cerez_s3_r7_retention = /** @type {(inputs: Cerez_S3_R7_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 dakika - 30 gün`)
};

const en_cerez_s3_r7_retention = /** @type {(inputs: Cerez_S3_R7_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 minutes - 30 days`)
};

const de_cerez_s3_r7_retention = /** @type {(inputs: Cerez_S3_R7_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 Minuten - 30 Tage`)
};

const ru_cerez_s3_r7_retention = /** @type {(inputs: Cerez_S3_R7_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 минут - 30 дней`)
};

/**
* | output |
* | --- |
* | "30 minutes - 30 days" |
*
* @param {Cerez_S3_R7_RetentionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r7_retention = /** @type {((inputs?: Cerez_S3_R7_RetentionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R7_RetentionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r7_retention(inputs)
	if (locale === "de") return de_cerez_s3_r7_retention(inputs)
	if (locale === "ru") return ru_cerez_s3_r7_retention(inputs)
	return tr_cerez_s3_r7_retention(inputs)
});